<template lang="pug">
div
  h1.unicorn-h1.mt-4 Создание заявки

  .flex.flex-col.gap-4.my-8(class="md:flex-row md:items-center md:justify-between")
    SelectClasses(
      @class-selected="onClassSelected"
      :selectedClassId="$route.params.classId"
      :classes="classes"
    )
    
    .flex.items-center.justify-between.gap-4(v-if="$route.params.classId" class="md:justify-end")
      .flex.items-center.gap-2(v-if="learners.length > 0")
        u-switch.master-toggle(
          @change="toggleAllCouponsImmediate"
          :modelValue="allCouponsSelected"
          :variant="allCouponsSelected ? 'success' : 'primary'"
          :icon="allCouponsSelected ? 'mdi-checkbox-multiple-marked' : 'mdi-checkbox-multiple-blank-outline'"
          :label="allCouponsSelected ? 'Снять всё' : 'Выбрать всё'"        )
      
      .flex.gap-2
        ArchiveButton
        RecoveryButton

  .grid.grid-cols-1(class="md:mb-0")
    Request(
      v-if="$route.params.classId"
      v-show="ok && !loading"
      ref="requestComponent"
      :learners="learners"
      :classInfo="classInfo"
      @close-request="closeRequestConfirm"
      @request-sent="handleRequestSent"
    )

    CoreLoading(v-if="loading")

    u-alert(v-if="!loading && !$route.params.classId" variant="info" icon="mdi-information")
      template(#title) Как оформить заявку?
      | Для оформления заявки выберите соответсвующий класс из списка доступных выше.

    u-dialog(persistent width="360" v-model="confirm")
      template
        u-card
          u-card-title Отправка заявки
          u-card-body
            u-alert(variant="danger") Внимание! Это действие нельзя отменить после подтверждения
            p.mt-4.font-medium Вы отправляете заявку в столовую:
            table.mt-2
              tr(v-for="entry in waitingRequest.stats" :key="entry.id")
                td {{ entry.name }}
                td: span.ml-2.text-red-600 {{ entry.count }} шт.
          u-card-actions
            u-spacer
            u-button.mr-2(@click="confirm = false" variant="secondary" text) Отмена
            u-button(@click="closeRequest" variant="danger") Продолжить

  offline(v-if="offlineError" @close="offlineError = false")
</template>

<script>
import { sortBy } from "lodash";

import Api from "../services/Api";
import Offline from "@/app/shared/components/Offline";
import CoreLogo from "@/app/shared/core/CoreLogo";
import UserProfile from "@/app/shared/new-component/UserProfile";
import AppLogo from "@/app/shared/new-component/AppLogo";
import AppSidebar from "@/app/shared/new-component/AppSidebar";

export default {
  components: { AppSidebar, AppLogo, UserProfile, CoreLogo, Offline },
  data() {
    return {
      learners: [],
      classInfo: null,
      classes: [],
      request: {},
      socialGroups: [],

      offlineError: false,
      confirm: false,
      dialog: true,

      waitingRequest: { classId: null, body: null },

      ok: false,
      loading: false,
      error: false,

      autoUpdateId: null,
      allCouponsSelected: false
    };
  },

  watch: {
    async $route() {
      const { classId } = this.$route.params;
      if (!classId) return;

      try {
        this.loading = true;
        await this.loadClassData(classId);
        this.ok = true;
      } catch (error) {
        this.ok = false;
        this.error = error;
      } finally {
        this.loading = false;
      }
    }
  },

  async mounted() {
    const { classId } = this.$route.params;

    try {
      this.loading = true;

      await this.loadClasses();

      if (classId) {
        await this.loadClassData(classId);
      }

      this.loading = false;
      this.ok = true;
    } catch (error) {
      this.ok = false;
      this.loading = false;
      this.error = error;
    }

    await this.startAutoUpdate();
  },

  beforeDestroy() {
    this.stopAutoUpdate();
  },

  methods: {
    async loadClasses() {
      try {
        const { data: classes } = await Api.classes.getClasses();
        this.classes = classes;
      } catch (error) {
        console.error("Error loading classes:", error);
        throw error;
      }
    },

    onClassSelected(classItem) {
      this.classInfo = classItem;
    },

    async loadClassData(classId) {
      await this.loadEntrants(classId);

      this.classInfo = this.classes.find(c => c.id == classId);

      if (!this.classInfo) {
        await this.loadClasses();
        this.classInfo = this.classes.find(c => c.id == classId);
      }
    },

    async startAutoUpdate() {
      const { classId } = this.$route.params;
      await this.stopAutoUpdate();
      this.autoUpdateId = setInterval(() => {
        this.getServerTime(classId);
      }, 5000);
    },

    async stopAutoUpdate() {
      clearInterval(this.autoUpdateId);
    },

    async getServerTime() {
      await Api.time();
    },

    async loadEntrants(classId) {
      const { data: learners } = await Api.classes.getClassLearners(classId);
      this.learners = sortBy(learners, ["surname", "name"]);
    },

    toggleAllCouponsImmediate() {
      this.allCouponsSelected = !this.allCouponsSelected;

      requestAnimationFrame(() => {
        if (this.$refs.requestComponent) {
          this.$refs.requestComponent.toggleAllCoupons(this.allCouponsSelected);
        }
      });
    },

    async closeRequestConfirm(req) {
      this.confirm = true;
      this.waitingRequest = req;
    },

    handleRequestSent() {
      this.allCouponsSelected = false;
    },

    async closeRequest() {
      const { classId, body } = this.waitingRequest;

      try {
        await Api.requests.closeRequest(classId, body);
        await this.loadClassData(classId);

        this.allCouponsSelected = false;
      } catch (error) {
        const { status } = (error && error.response) || { status: error };
        alert(this.getRequestCloseErrorDesc(status));
      } finally {
        this.confirm = false;
      }

      this.waitingRequest = { classId: null, body: null };
    },

    getRequestCloseErrorDesc(httpErrorCode) {
      switch (httpErrorCode) {
        case 402:
          return "Недостаточно средств. Попробуйте обновить сраницу (клавиша F5)";
        case 404:
          return "Заявка не найдена. Попробуйте перезагрузить страницу (клавиша F5)";
        case 422:
          return "Ошибка в 'Своем заказе'";
        case 409:
          return "Повторное оформление заявки";
        case 500:
          return "Ошибка сервера. Попробуйте позднее";
        case 502:
          return "Тех. работы на сервере. Попробуйте через 5 минут";
        default:
          this.offlineError = true;
          return "Неопознанная ошибка: " + httpErrorCode;
      }
    }
  }
};
</script>
<style scoped>
.switches-wrapper {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
  min-height: 40px;
}

.mobile-switch,
.desktop-switch {
  isolation: isolate;
  position: relative !important;
  z-index: 0 !important;
  transition: none !important;
}

.mobile-switch >>> *,
.desktop-switch >>> * {
  z-index: 0 !important;
  transition: none !important;
}

.mobile-switch >>> .v-input__icon,
.mobile-switch >>> .mdi,
.mobile-switch >>> i,
.mobile-switch >>> .v-icon,
.mobile-switch >>> svg,
.desktop-switch >>> .v-input__icon,
.desktop-switch >>> .mdi,
.desktop-switch >>> i,
.desktop-switch >>> .v-icon,
.desktop-switch >>> svg {
  z-index: 0 !important;
  position: relative !important;
  transition: none !important;
}

@media (max-width: 767px) {
  .mobile-switch {
    display: inline-flex !important;
    align-items: center !important;
    vertical-align: middle !important;
    flex-shrink: 0;
  }

  .mobile-switch >>> .v-input,
  .mobile-switch >>> .v-input__control,
  .mobile-switch >>> .v-input__slot {
    min-height: 40px !important;
    transition: none !important;
  }
}
</style>
